<template>
  <div>
    <Loading :value="loading"></Loading>
    <!-- MODAL ADD TYPE PROJET -->
    <v-dialog
      v-model="dialogAjoutTypeProjet"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Ajouter/Editer un type de chantier</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeForm()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-form
            id="formTypeProj"
            :rules="rules"
            label-position="top"
            ref="formTypeProj"
            :model="formTypeProj"
            class="demo-ruleForm"
          >
            <v-layout row wrap class="text-xs-center text-sm-left">
              <v-layout row>
                <v-flex xs12 md4 mr-1>
                  <div>
                    <el-form-item label="Code de type chantier" prop="code">
                      <el-input
                        name="code"
                        placeholder="Code de Type de chantier"
                        v-model="formTypeProj.code"
                        style="width:100%"
                      ></el-input>
                    </el-form-item>
                  </div>
                </v-flex>

                <v-flex xs12 md4 mr-1>
                  <div>
                    <el-form-item label="Type de chantier" prop="libelle">
                      <el-input
                        name="libelle"
                        placeholder="Type de chantier"
                        v-model="formTypeProj.libelle"
                        style="width:100%"
                      ></el-input>
                    </el-form-item>
                  </div>
                </v-flex>
                <v-flex xs12 md4>
                  <div>
                    <el-form-item label="Description" prop="description">
                      <el-input
                        type="textarea"
                        name="description"
                        placeholder="Description"
                        v-model="formTypeProj.description"
                        style="width:100%"
                      ></el-input>
                    </el-form-item>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row class="text-xs-right">
                <v-flex xs12>
                  <v-btn @click="closeForm()" color="grey" dark
                    >Annuler <v-icon right>remove_circle</v-icon></v-btn
                  >
                  <v-btn icons color="green" @click="submitTypeProjet()" dark
                    >Enregistrer <v-icon right>save</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-layout>
          </el-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  name: "formTypeProjet",
  components: { Loading },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editedTypeProjet: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogAjoutTypeProjet: false,
      formTypeProj: {
        id: "",
        libelle: "",
        description: ""
      },
      rules: {
        libelle: [
          {
            required: true,
            message: "Veuillez  saisir un libelle",
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: "Veuillez  saisir une description",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "Veuillez  saisir le code",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    show: function(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutTypeProjet = true;
        if (this.editedTypeProjet != null) {
          this.formTypeProj = this.editedTypeProjet;
          //this.loadTypeProjet();
        }
      } else {
        this.dialogAjoutTypeProjet = false;
      }
    }
  },
  methods: {
    closeForm() {
      this.resetForm();
      this.$emit("close");
    },
    submitTypeProjet() {
      this.$refs["formTypeProj"].validate(valid => {
        if (valid) {
          this.loading = true;
          let form = document.getElementById("formTypeProj");
          let data = new FormData(form);
          let url = "";
          if (this.editedTypeProjet != null) {
            url =
              this.domaine +
              "projet/" +
              this.editedTypeProjet.id +
              "/edit/type/projet";
          } else {
            url = this.domaine + "projet/new/type/projet";
          }
          data.append("idUser", this.user.id);
          this.$http.post(url, data).then(
            response => {
              this.loading = false;
              if (response.body.code == 3) {
                this.$message.error(response.body.message);
                return;
              }
              this.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Type de chantier enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              this.closeForm();
            },
            error => {
              this.loading = false;
              this.$message.error(
                "Erreur lors de l'enregistrement du type projet "
              );
            }
          );
        }
      });
    }, //submit
    resetForm() {
      this.formTypeProj.libelle = "";
      this.formTypeProj.description = "";
      this.formTypeProj.code = "";
    }
  } // methods
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/divers/formTypeProjet.vue